export default __webpack_public_path__ + "images/A1.27b6cba.png";